import { Map } from 'immutable';

import { setFilesErrors, setWhenMadeErrors } from '../product/errors';

import { ERROR, OPERATIONS, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { ERRORS } from '../../constants/validations';
import { ETSY } from '../../constants/channels';
import { FORM } from '../../constants/forms';

export function editFiles({ product: source, value }) {
  let product = source;
  const channel = product.get('channel');

  product = setFilesErrors({ channel, product: product.setIn([FORM.FILES, VALUE], value) });

  if (product.hasIn([ERROR, ATTRIBUTE.FILES])) return { product, operations: [] };

  switch (channel) {
    case ETSY: {
      product = setWhenMadeErrors({ product });

      if (product.getIn([ERROR, ATTRIBUTE.WHEN_MADE]) === ERRORS.DETAILS.DIGITAL_MADE_TO_ORDER) {
        return { product, operations: [] };
      }

      break;
    }

    default: {
      break;
    }
  }

  return { product, operations: [Map({ type: OPERATIONS[channel].FILES.CHANGE_TO, value })] };
}
